module.exports = __webpack_public_path__ + "static/media/wavy_left2.b4373fd5.png";